<div class="pm-messenger-redirect">
  <ion-spinner name="dots"></ion-spinner>
  <div class="pm-messenger-redirect__text">Loading…</div>
</div>
